module.exports = __webpack_public_path__ + "static/media/new-york-83.f10e1cd1.jpg";